import { ReactNode } from "react";

import styles from "./ButtonGroup.module.css";

function ButtonGroup({ children }: any) {
  return (
    <div className="bg-white flex items-start xs:justify-center border border-gray-300 rounded-md">
      {children?.map((item: ReactNode, idx: number) => (
        <div key={idx} className={styles.buttonGroup}>
          {item}
        </div>
      ))}
    </div>
  );
}

export default ButtonGroup;
